import React, { createContext, useContext } from 'react';
import cn from '../../ui/primitives/cn';

/**
 * True inside a FormGrid. A field reads it to fill its grid column instead of sizing
 * itself by `fieldWidth`, which is a width for a field on its own line.
 */
export const FormGridContext = createContext(false);

/** Whether the calling field sits in a FormGrid column. */
export const useInFormGrid = () => useContext(FormGridContext);

/**
 * The edit card's field grid (redesign iteration 1): two columns, or three for short
 * fields, that the fields flow into in source order. A field that needs the whole row
 * takes the `form-grid-full` class on its outermost element. Laid out in css/editor.css.
 *
 * Opt-in per form, and only for a form whose fields are one flat list: wrapping fields
 * that sit inside their own containers would put the containers in the grid instead.
 */
const FormGrid = ({ columns = 2, className, children }) => (
  <FormGridContext.Provider value>
    <div className={cn('form-grid', columns === 3 && 'form-grid-3', className)}>{children}</div>
  </FormGridContext.Provider>
);

export default FormGrid;
